import React from "react";
import { Table, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Card from "components/ui/Card";
import styles from "./AuthorList.module.css";

function AuthorList({
  dataSource,
  loading,
  page,
  pageSize,
  onChangePage,
  total,
}) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("CREATED"),
      dataIndex: "created",
      key: "created",
      align: "center",
      width: 150,
      render: (created) => {
        const date = moment(created).format("YYYY-MM-DD HH:mm");
        return <span className="text_medium">{date}</span>;
      },
    },
    {
      title: t("UPDATED_AGENT"),
      dataIndex: "username",
      key: "username",
      render: (agentName, row) => {
        return (
          <span className="text_medium">
            {agentName} ({row.role})
          </span>
        );
      },
    },
    {
      title: t("TARGET"),
      dataIndex: "update_username",
      key: "update_username",
      render: (targetUser, row) => {
        return (
          <span className="text_medium">
            {targetUser} - {row.update_role} - {row.update_agent_id}
          </span>
        );
      },
    },
  ];
  return (
    <Card>
      <span className="text_title">{t("CALL_LOG_LIST")}</span>
      <span className="text-small-11">
        {t("TOTAL_RECORD")} {total}
      </span>
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={false}
      />
      <div className={styles.pagination_container}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={total}
          onChange={onChangePage}
        />
      </div>
    </Card>
  );
}

export default AuthorList;
